// extracted by mini-css-extract-plugin
module.exports = {"chat":"_2aQvC","contact":"_2qeM4","point":"HSvum","subtitle":"_2cwVc","terms":"XfNdC","termsList":"_1UHhv","title":"_2sFOE"};